import { PaginationFilter } from "../../../../shared/interfaces";
import { BlocEvent } from "../../../../shared/bloc/base-bloc";

export abstract class NotificationsEvent extends BlocEvent {}

export class GetLatestNotificationsEvent extends NotificationsEvent {
    constructor(public filter: PaginationFilter) {
      super()
    }
  }
  
export class LoadMoreNotificationsEvent extends NotificationsEvent {
    constructor(public filter: PaginationFilter) {
        super()
    }
}

export class MarkNotificationAsReadEvent extends NotificationsEvent {
    constructor(public notificationId: string) {
        super();
    }
}

export class GetUnseenNotificationsCountEvent extends NotificationsEvent {}